import { render, staticRenderFns } from "./SpecialtiesIndex.vue?vue&type=template&id=258519dc&scoped=true"
import script from "./SpecialtiesIndex.vue?vue&type=script&lang=js"
export * from "./SpecialtiesIndex.vue?vue&type=script&lang=js"
import style0 from "./SpecialtiesIndex.vue?vue&type=style&index=0&id=258519dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258519dc",
  null
  
)

export default component.exports